<template>
	<div style="height: 100%;position: relative;">
		<div class="echarsTop">
			<div class="echarsLi">
				<div class="liTap">
					<div class="tap-li" @click="changeRightTopCheck('1')">
						<img :src="rightTopCheck == '1' ? selectImg0 : selectImg1" alt="">
						<div class="tap-name">
							<span>{{ languageJson.TemperatureandHumidity }}</span>
						</div>
					</div>
					<div class="tap-li" @click="changeRightTopCheck('2')" style="margin-left: 10px;">
						<img :src="rightTopCheck == '2' ? selectImg0 : selectImg1" alt="">
						<div class="tap-name">
							<span>{{ languageJson.AirQuality }}</span>
						</div>
					</div>
				</div>
				<div class="daySelect" style="width: 20%;margin-right: 10px;">
					<el-select v-model="robotNum" style="width: 100%;height: 100%;">
						<el-option v-for="item in robotList" :key="item.robotId" :label="item.name"
							:value="item.number"></el-option>
					</el-select>
				</div>
				<div class="daySelect" style="width: 20%;">
					<el-select v-model="dayValue" style="width: 100%;height: 100%;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div v-if="rightTopCheck == '1'" style="width: 100%;height: 80%;">
			<div v-if="noneLeft" style="width: 100%;padding: 20px 0;font-size: 0.9vw;font-weight: 600;color: white;position: absolute;bottom: 10px;left: 0%;">
				<img src="../../../../static/imgV2/none.png" style="width: 30%;" alt="">
				<div style="margin-top: 10px;">{{ languageJson.noneTemperatureandHumidity }}</div>
			</div>
			<div v-if="rightTopCheck == '1'" ref="echar1_2" :style="{width: '100%',height: '100%',opacity: !noneLeft ? 1 : 0,zIndex: 99}"></div>
		</div>
		<div v-if="rightTopCheck == '2'" style="width: 100%;height: 80%;">
			<div v-if="noneRight" style="width: 100%;padding: 20px 0;font-size: 0.9vw;font-weight: 600;color: white;position: absolute;bottom: 10px;left: 0%;">
				<img src="../../../../static/imgV2/none.png" style="width: 30%;" alt="">
				<div style="margin-top: 10px;">{{ languageJson.noneAirQuality }}</div>
			</div>
			<div v-if="rightTopCheck == '2'" ref="echar1_3" :style="{width: '100%',height: '100%',opacity: !noneRight ? 1 : 0,zIndex: 99}"></div>
		</div>
	</div>
</template>

<script>
	import {
		environmentRobotNum,
		robotSelect
	} from '@/api/indexV2'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				selectImg0: require('../../../../static/imgV2/checkSelect-0.png'),
				selectImg1: require('../../../../static/imgV2/checkSelect-1.png'),
				rightTopCheck: '1',
				robotNum: 'ROB22120206',
				robotList: [],
				dayValue: '1',
				options: [{
					value: '1',
					label: languageJson.Hour24
				}, {
					value: '2',
					label: languageJson.Days7
				}],
				environmentVos: {
					humidityList: [],
					pm25: [],
					pm10: [],
					tempList: [],
					timeList: []
				},
				myChart_1: null,
				myChart_2: null,
				noneLeft: false,
				noneRight: false
			}
		},
		props: {
			timeStamp: Number,
			changeTime: Boolean
		},
		mounted() {
			let that = this
			that.robotSelect(getItem('tenantInfoId'))
		},
		methods: {
			fontSizeCh(res) {
				// 获取屏幕宽度
				if (window.screen.width <= 1920) {
					return res
				} else if (window.screen.width > 1920 && window.screen.width <= 3200) {
					return res * 1.5
				} else if (window.screen.width > 3200 && window.screen.width <= 3840) {
					return res * 2.2
				} else if (window.screen.width > 3840) {
					return res * 3
				}
			},
			robotSelect(tId) {
				let that = this
				robotSelect(tId).then(res => {
					if (res && res.data) {
						that.robotNum = res.data[0].number
						that.robotList = res.data
						that.environmentRobotNum(that.robotNum, that.dayValue, that.rightTopCheck)
					}
				})
			},
			environmentRobotNum(number, day, type) {
				let that = this
				environmentRobotNum(number, day).then(res => {
					if (res && res.data) {
						that.environmentVos = {
							...res.data,
							pm25: res.data['pm2.5']
						}
						if (res.data.tempList.length == 0 || res.data.humidityList.length == 0) {
							that.noneLeft = true
						} else {
							that.noneLeft = false
						}
						if (res.data['pm2.5'].length == 0 || res.data.pm10.length == 0) {
							that.noneRight = true
						} else {
							that.noneRight = false
						}
						if (type == '1') {
							this.drawEcharRight1()
						} else {
							this.drawEcharRight2()
						}
					}
				})
			},
			drawEcharRight1() {
				let that = this
				let yDataTempKey = [];
				let yDataTempVal = [];
				let yDataHumKey = [];
				let yDataHumVal = [];
				let dataVo = that.environmentVos;
				dataVo.tempList.forEach(res => {
					yDataTempKey.push(Object.keys(res)[0])
				})
				dataVo.humidityList.forEach(res => {
					yDataHumKey.push(Object.keys(res)[0])
				})
				dataVo.timeList.forEach(refv => {
					let fIndex = yDataTempKey.indexOf(refv)
					if (fIndex == -1) {
						yDataTempVal.push(null)
					} else {
						dataVo.tempList.forEach(ressk => {
							if (Object.keys(ressk)[0] == refv) yDataTempVal.push(ressk[refv])
						})
					}
				})

				dataVo.timeList.forEach(refv => {
					let fIndex = yDataHumKey.indexOf(refv)
					if (fIndex == -1) {
						yDataHumVal.push(null)
					} else {
						dataVo.humidityList.forEach(ressk => {
							if (Object.keys(ressk)[0] == refv) yDataHumVal.push(ressk[refv])
						})
					}
				})

				that.$nextTick(() => {
					var myChart = that.$echarts.init(that.$refs.echar1_2)
					myChart.clear();
					that.myChart_1 = myChart
					let option = {
						tooltip: {
							trigger: 'axis',
							textStyle: {
								fontSize: that.fontSizeCh(14)
							},
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						},
						legend: {
							data: [languageJson.Temperature, languageJson.Humidity],
							color: ['#ffffff', '#00FF00'],
							textStyle: {
								color: '#ffffff',
								fontSize: that.fontSizeCh(14)
							},
							top: '1%',
							right: '5%'
						},
						grid: {
							top: '20%',
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: [{
							type: 'category',
							boundaryGap: false,
							data: dataVo.timeList,
							axisLabel: {
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						}],
						yAxis: [{
							type: 'value',
							axisLabel: {
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						}],
						series: [
							{
								name: languageJson.Humidity,
								type: 'line',
								// stack: 'Total',
								areaStyle: {},
								emphasis: {
									focus: 'series'
								},
								data: yDataHumVal
							},
							{
								name: languageJson.Temperature,
								type: 'line',
								// stack: 'Total',
								areaStyle: {},
								emphasis: {
									focus: 'series'
								},
								data: yDataTempVal
							}
						]
					};
					myChart.setOption(option)
				})
			},
			drawEcharRight2() {
				let that = this;
				let xData = [];
				let yDataPm25Key = [];
				let yDataPm25Val = [];
				let yDataPm10Key = [];
				let yDataPm10Val = [];
				let dataVo = that.environmentVos;
				dataVo.pm25.forEach(res => {
					yDataPm25Key.push(Object.keys(res)[0])
				})
				dataVo.pm10.forEach(res => {
					yDataPm10Key.push(Object.keys(res)[0])
				})

				dataVo.timeList.forEach(refv => {
					let fIndex = yDataPm25Key.indexOf(refv)
					if (fIndex == -1) {
						yDataPm25Val.push(null)
					} else {
						dataVo.pm25.forEach(ressk => {
							if (Object.keys(ressk)[0] == refv) yDataPm25Val.push(ressk[refv])
						})
					}
				})

				dataVo.timeList.forEach(refv => {
					let fIndex = yDataPm10Key.indexOf(refv)
					if (fIndex == -1) {
						yDataPm10Val.push(null)
					} else {
						dataVo.pm10.forEach(ressk => {
							if (Object.keys(ressk)[0] == refv) yDataPm10Val.push(ressk[refv])
						})
					}
				})
				that.$nextTick(() => {
					var myChart = that.$echarts.init(that.$refs.echar1_3);
					myChart.clear();
					that.myChart_2 = myChart
					let maxArray = yDataPm25Val.concat(yDataPm10Val)
					maxArray.push(Number(dataVo['tenantPm2.5']))

					let option = {
						tooltip: {
							trigger: 'axis',
							textStyle: {
								fontSize: that.fontSizeCh(14)
							},
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						},
						legend: {
							data: ['pm2.5', 'pm10'],
							color: ['#ffffff', '#00FF00'],
							textStyle: {
								color: '#ffffff',
								fontSize: that.fontSizeCh(14)
							},
							top: '1%',
							right: '5%'
						},
						grid: {
							top: '20%',
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: [{
							type: 'category',
							boundaryGap: false,
							data: that.environmentVos.timeList,
							axisLabel: {
								textStyle: {
									color: '#ffffff',
									fontSize: that.fontSizeCh(14)
								}
							}
						}],
						yAxis: [
							{
								type: 'value',
								max: Math.max(...maxArray) + 20,
								axisLabel: {
									textStyle: {
										color: '#ffffff',
										fontSize: that.fontSizeCh(14)
									}
								}
							}
						],
						series: [
							{
								name: 'pm10',
								type: 'line',
								// stack: 'Total',
								areaStyle: {},
								emphasis: {
									focus: 'series'
								},
								data: yDataPm10Val
							},
							{
								name: 'pm2.5',
								type: 'line',
								// stack: 'Total',
								areaStyle: {},
								emphasis: {
									focus: 'series'
								},
								data: yDataPm25Val,
								markLine: {
									data: [{
										silent: false,
										yAxis: Number(dataVo['tenantPm2.5']),
										type: 'average',
										name: 'Avg',
										lineStyle: {
											type: 'dashed',
											color: '#ffffc5',
											width: 3
										},
										label: {
											color: '#ffffc5',
											formatter: "差"
										}
									}]
								}
							}
						]
					};
					myChart.setOption(option)
				})
			},
			changeRightTopCheck(type) {
				this.rightTopCheck = type
				if (type == '1') {
					this.drawEcharRight1()
				} else {
					this.drawEcharRight2()
				}
			}
		},
		watch: {
			changeTime: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					if (this.rightTopCheck == '1') {
						this.changeRightTopCheck('2')
					} else {
						this.changeRightTopCheck('1')
					}
				}
			},
			dayValue: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					this.environmentRobotNum(this.robotNum, newData, this.rightTopCheck)
				}
			},
			robotNum: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					this.environmentRobotNum(newData, this.dayValue, this.rightTopCheck)
				}
			},
			timeStamp: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					let that = this
					if (newData) {
						if (that.myChart_1) {
							that.myChart_1.resize()
						}
						if (that.myChart_2) {
							that.myChart_2.resize()
						}
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.daySelect /deep/ .el-input__inner {
		background-color: #0B258C;
		color: white;
		border: 1px solid #1D71FF;
		height: 1.5vw;
		line-height: 1.5vw;
	}

	.daySelect /deep/ .el-input--suffix .el-input__inner {
		padding-right: 0px;
		font-size: 0.7vw;
	}

	.daySelect /deep/ .el-input__icon {
		height: 1.5vw;
		line-height: 1.5vw;
	}

	.daySelect /deep/ .el-select .el-input,
	.el-select-dropdown .el-select-dropdown__item {
		font-size: 0.7vw;
		height: 1.3vw;
		line-height: 1.3vw;
	}

	.echarsTop {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 15%;
		margin-top: 15px;

		.echarsLi {
			display: flex;
			justify-content: space-between;
			width: 90%;
			margin: 10px auto;
			align-items: center;

			.liTap {
				display: flex;
				width: 60%;
				margin-top: 5px;

				.tap-li {
					width: 45%;
					height: 100%;
					position: relative;

					.tap-name {
						position: absolute;
						top: 0;
						left: 10%;
						width: 80%;
						height: 80%;
						display: flex;
						justify-content: center;
						align-items: center;
						color: white;
						font-weight: 700;
						cursor: pointer;
						font-size: 0.9vw;
					}

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/customIndex/components/rightBottom.vue